import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

import router from './router/'
import store from './store/'
import VueSnackbar from 'vue-snack'

import './registerServiceWorker'
import './plugins/storage'
import './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import './theme/default.sass'
import './theme/custom.sass'
import '../node_modules/vue-snack/src/styles/styles.scss'

import App from './App.vue'
import vuetify from './plugins/vuetify'
import { ROOT_API } from './util/constants'

Vue.config.productionTip = true

Vue.prototype.$http = axios
Vue.prototype.$api = axios.create({
  baseURL: ROOT_API,
})

Vue.prototype.moment = moment

Vue.use(VueSnackbar, {
  position: 'top-right',
  time: 5000,
  close: true,
  methods: [{ name: 'warning', color: '#ff5722' }],
})

const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
})

app.$mount('#app')
